export default function yearsAndDays(value) {
    let yearString = '',
        dayString = '',
        andString = '',
        days = value % 365,
        years = (value - days) / 365;

    if (years > 0) {
        yearString = years + (years === 1 ? ' year' : ' years');
    }

    if (days > 0) {
        dayString = days + (days === 1 ? ' day' : ' days');
    }

    if (days > 0 && years > 0) {
        andString = ' and ';
    }

    return yearString + andString + dayString;

}